import PropTypes from "prop-types";
export default function TextArea({ value, changeFun, id, inputName, disabled }) {
  return (
    <>
      <div className="row-content">
        <div className="">
          <textarea
            className="text-area-event-calendar"
            id={id}
            name={inputName}
            value={value}
            onChange={changeFun}
            disabled={disabled ?? false}
          ></textarea>
        </div>
      </div>
    </>
  );
}

TextArea.propTypes = {
  value: PropTypes.string.isRequired,
  changeFun: PropTypes.func,
  id: PropTypes.string,
  inputName: PropTypes.string,
  disabled : PropTypes.bool
};
